import React, { useState } from "react";
import RollForwardPreview from "./RollForwardPreview";

export default function RollForwardModal({ scope, onClose }) {
  const [label, setLabel] = useState("");

  if (!scope) return null;

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "white", borderRadius: 12, padding: 24, width: "min(900px, 92vw)", maxHeight: "86vh", overflowY: "auto" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: 0, color: "#111827" }}>
            {label || "Roll forward"}
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#6b7280", lineHeight: 1 }}
          >
            ×
          </button>
        </div>
        {/* RollForwardPreview owns the single fetch of previewRollForward for
            this scope; it reports the scope_label back here via onLabel so
            the modal doesn't issue a second, redundant request just for its
            heading. */}
        <RollForwardPreview scope={scope} onLabel={setLabel} />
      </div>
    </div>
  );
}
